import { GeneralActions } from '../../../../../actions';

const Mutations = Object.freeze({
	SET_HEADERS: 'projectSettings/connectors/connectorHeaders/SET_HEADERS',
	SET_SELECTED_CONNECTOR:
		'projectSettings/connectors/connectorHeaders/SET_SELECTED_CONNECTOR',
});

export const Actions = Object.freeze({
	CLEAR: 'projectSettings/connectors/connectorHeaders/CLEAR',
	LOAD_SELECTED_CONNECTOR:
		'projectSettings/connectors/connectorHeaders/LOAD_SELECTED_CONNECTOR',
	LOAD: 'projectSettings/connectors/connectorHeaders/LOAD',
	ADD: 'projectSettings/connectors/connectorHeaders/ADD',
	UPDATE: 'projectSettings/connectors/connectorHeaders/UPDATE',
	DELETE: 'projectSettings/connectors/connectorHeaders/DELETE',
});

export const Getters = Object.freeze({
	SELECTED_CONNECTOR:
		'projectSettings/connectors/connectorHeaders/SELECTED_CONNECTORS',
	PARENT_HEADERS:
		'projectSettings/connectors/connectorHeaders/PARENT_HEADERS',
	CHILD_HEADERS: 'projectSettings/connectors/connectorHeaders/CHILD_HEADERS',
});

import dataService from '../../../../../../services/data/projectSettingsService';
import { gridViewConnectorHeaderType } from '../../../../../../enums/gridViewConnectorHeaderType';
export default {
	state: {
		headers: [],
		selectedConnector: null,
	},
	mutations: {
		[Mutations.SET_SELECTED_CONNECTOR](state, item) {
			state.selectedConnector = item;
		},
		[Mutations.SET_HEADERS](state, items) {
			state.headers = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_HEADERS, []);
				commit(Mutations.SET_SELECTED_CONNECTOR, null);
				resolve();
			});
		},

		[Actions.LOAD_SELECTED_CONNECTOR]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_SELECTED_CONNECTOR, item);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},

		[Actions.LOAD]({ commit, dispatch }, selectedConnector) {
			return new Promise((resolve) => {
				dataService
					.getGridViewConnectorHeadersByConnector(selectedConnector)
					.then((resp) => {
						commit(Mutations.SET_HEADERS, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},

		[Actions.ADD]({ commit, state }, item) {
			return dataService
				.addGridViewConnectorHeaders(item)
				.then((resp) => {
					let headers = state.headers;
					headers.push(resp.data);
					commit(Mutations.SET_HEADERS, headers);
				});
		},
		[Actions.UPDATE]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateGridViewConnectorHeaders(item)
					.then(() => {
						let headers = state.headers;
						let index = headers.findIndex((x) => x.Id == item.Id);
						if (index >= 0) headers.splice(index, 1, item);
						commit(Mutations.SET_HEADERS, headers);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DELETE]({ commit, state }, item) {
			return dataService.deleteGridViewConnectorHeaders(item).then(() => {
				let headers = state.headers;
				let index = headers.findIndex((x) => x.Id == item.Id);
				if (index >= 0) headers.splice(index, 1);
				commit(Mutations.SET_HEADERS, headers);
			});
		},
	},
	getters: {
		[Getters.PARENT_HEADERS]: (state) => {
			if (state.headers && state.headers.length > 0) {
				let items = state.headers.filter(
					(x) => x.HeaderType == gridViewConnectorHeaderType.Parent
				);
				return JSON.parse(JSON.stringify(items));
			}
			return [];
		},
		[Getters.CHILD_HEADERS]: (state) => {
			if (state.headers && state.headers.length > 0) {
				let items = state.headers.filter(
					(x) => x.HeaderType == gridViewConnectorHeaderType.Child
				);
				return JSON.parse(JSON.stringify(items));
			}
			return [];
		},
		[Getters.SELECTED_CONNECTOR]: (state) => {
			if (!state.selectedConnector) return null;
			return JSON.parse(JSON.stringify(state.selectedConnector));
		},
	},
};
